import { useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { NewRequestForm } from "./NewRequestForm";
import { RequestList } from "./RequestList";
import { ThreadView } from "./ThreadView";
import { useIsMobile } from "@/hooks/use-mobile";

interface SupportPanelProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function SupportPanel({ open, onOpenChange }: SupportPanelProps) {
  const [selectedThreadId, setSelectedThreadId] = useState<string | null>(null);
  const [activeTab, setActiveTab] = useState<"new" | "requests">("new");
  const isMobile = useIsMobile();

  const handleThreadSelect = (threadId: string) => {
    setSelectedThreadId(threadId);
  };

  const handleBack = () => {
    setSelectedThreadId(null);
  };

  const handleRequestCreated = () => {
    setActiveTab("requests");
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side={isMobile ? "bottom" : "right"}
        className={isMobile ? "h-[90vh]" : "w-[500px] sm:w-[600px] sm:max-w-[600px]"}
      >
        <SheetHeader className="mb-4">
          <SheetTitle className="flex items-center gap-2">
            <span className="text-2xl">💬</span>
            Ask Nedra
          </SheetTitle>
        </SheetHeader>

        {selectedThreadId ? (
          <ThreadView
            threadId={selectedThreadId}
            onBack={handleBack}
            senderRole="user"
          />
        ) : (
          <Tabs value={activeTab} onValueChange={(v) => setActiveTab(v as "new" | "requests")}>
            <TabsList className="grid w-full grid-cols-2">
              <TabsTrigger value="requests">My Requests</TabsTrigger>
              <TabsTrigger value="new">New Request</TabsTrigger>
            </TabsList>
            <TabsContent value="requests" className="mt-4">
              <RequestList onSelectThread={handleThreadSelect} />
            </TabsContent>
            <TabsContent value="new" className="mt-4">
              <NewRequestForm onSuccess={handleRequestCreated} />
            </TabsContent>
          </Tabs>
        )}
      </SheetContent>
    </Sheet>
  );
}
